import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import {
  AvatarComponent,
  CheckboxComponent,
  OfferStatusIndicatorComponent,
} from '@recruitee/user-interface';
import { AnyGroup, LayoutBoardGroupHeader } from '@recruitee/views-types';
import { DefaultGroupHeaderComponent } from '@recruitee/views-ui';

@Component({
  selector: 'rt-group-header',
  standalone: true,
  imports: [
    DefaultGroupHeaderComponent,
    AvatarComponent,
    OfferStatusIndicatorComponent,
    CheckboxComponent,
  ],
  templateUrl: './group-header.component.html',
  styleUrls: ['./group-header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobsGroupHeaderComponent implements LayoutBoardGroupHeader {
  @Input() public group: AnyGroup;
  @Input() public selectionInGroup: LayoutBoardGroupHeader['selectionInGroup'];

  @Output() public select = new EventEmitter<AnyGroup>();
}
